mtl.alloy.factory['verify-delivery-date'] = (function($) {
    'use strict';

    return function(element, options) {

        var $element = $(element);

        $element.unbind('change').on('change', function(){
            verifyDateType($(this));
        });

        $('#app_checkout_delivery_deliveryDate').closest('.row').hide();
    };

    function verifyDateType(element)
    {
        var type = element.val();

        $.ajax({
            url: '/checkout/verify-delivery-date/?type='+type,
            cache: false,
            success: function(jsonContent){
                if(jsonContent.validDeliveryDays)
                {
                    var $validDays = [];
                    $.each( jsonContent.validDeliveryDays, function( key, value ) {
                        $validDays.push(key);
                    });

                    $("[data-init='datepicker']").val('');
                    $("[data-init='datepicker']").data('valid-days', $validDays);
                    
                    $("[data-init='datepicker']").datepicker("destroy");
                    mtl.alloy.process(element.closest('form'));

                    if(jsonContent.requireDatePicker)
                    {
                        $('#app_checkout_delivery_deliveryDate').closest('.row').show();
                    } else {
                        $('#app_checkout_delivery_deliveryDate').closest('.row').hide();
                    }

                }

            },
        });
    }

}(jQuery));
